import React, { useState } from 'react';
import { SparklesIcon, ShieldCheckIcon, HeartIcon } from './Icons';
import { sounds } from '../utils/audio';

export default function Footer({ onOpenParentGate }) {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email && email.includes('@')) {
      sounds.playSound('chest');
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <footer className="bg-slate-900 text-white pt-16 pb-12 border-t-4 border-kiki-yellow relative overflow-hidden">
      
      {/* Decorative background stars */}
      <div className="absolute top-8 left-12 text-slate-700 pointer-events-none select-none text-2xl">✨</div>
      <div className="absolute top-20 right-20 text-slate-700 pointer-events-none select-none text-3xl">⭐</div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 pb-12 border-b border-slate-800">
          
          {/* Brand Col */}
          <div className="lg:col-span-5 space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-2xl bg-white p-1 shadow-md">
                <img src="/assets/images/logo.png" alt="Kiki & Kids Logo" className="w-full h-full object-contain" />
              </div>
              <div>
                <span className="font-heading font-black text-2xl tracking-tight text-white flex items-center gap-1">
                  Kiki <span className="text-kiki-coral">&amp;</span> Kids
                </span>
                <span className="text-xs text-kiki-blue font-bold tracking-wider uppercase block -mt-1">
                  kikiandkids.com
                </span>
              </div>
            </div>

            <p className="text-sm text-slate-400 font-medium leading-relaxed max-w-sm">
              Creating delightful, ad-free educational games and maths adventures for preschoolers and young learners ages 2–8. Offline-first, calming, and safe.
            </p>

            <div className="flex items-center gap-2 pt-2 text-xs font-bold text-slate-400">
              <ShieldCheckIcon className="w-4 h-4 text-kiki-green" />
              <span>COPPA &amp; GDPR-K Compliant • Zero Third-Party Trackers</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-3 space-y-3">
            <h4 className="font-heading font-black text-sm uppercase tracking-wider text-slate-300">
              Explore The World
            </h4>
            <ul className="space-y-2 text-sm font-semibold text-slate-400">
              <li>
                <a href="#apps" onClick={() => sounds.playSound('tap')} className="hover:text-white transition-colors">
                  iOS &amp; iPadOS Apps
                </a>
              </li>
              <li>
                <a href="#playground" onClick={() => sounds.playSound('pop')} className="hover:text-kiki-yellow transition-colors flex items-center gap-1.5">
                  <span>Interactive Playground</span>
                  <span className="px-1.5 py-0.2 bg-kiki-coral text-white text-[10px] rounded-full">Free</span>
                </a>
              </li>
              <li>
                <a href="#characters" onClick={() => sounds.playSound('tap')} className="hover:text-white transition-colors">
                  Meet Miss Kiki &amp; Friends
                </a>
              </li>
              <li>
                <a href="#curriculum" onClick={() => sounds.playSound('tap')} className="hover:text-white transition-colors">
                  Curriculum &amp; Pedagogy
                </a>
              </li>
              <li>
                <a href="#printables" onClick={() => sounds.playSound('tap')} className="hover:text-white transition-colors">
                  Free Activity Worksheets
                </a>
              </li>
              <li>
                <button
                  onClick={() => { sounds.playSound('tap'); onOpenParentGate(); }}
                  className="hover:text-kiki-purple transition-colors text-left"
                >
                  Parent Zone Gate 🔒
                </button>
              </li>
            </ul>
          </div>

          {/* Newsletter Box */}
          <div className="lg:col-span-4 space-y-3">
            <h4 className="font-heading font-black text-sm uppercase tracking-wider text-slate-300">
              Miss Kiki's Learning Circle
            </h4>
            <p className="text-xs text-slate-400 font-medium leading-relaxed">
              Join thousands of parents. Get new free printables, island updates, and early learning tips delivered monthly. Zero spam.
            </p>

            {subscribed ? (
              <div className="p-4 rounded-2xl bg-emerald-950/80 border border-emerald-600 text-emerald-300 text-xs font-bold flex items-center gap-2">
                <span>🎉</span>
                <span>Welcome to the circle! Miss Kiki sent a smile your way.</span>
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="space-y-2">
                <div className="flex gap-2">
                  <input
                    type="email"
                    required
                    placeholder="Enter parent email..."
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-2.5 rounded-2xl bg-slate-800 border border-slate-700 text-white placeholder-slate-500 text-xs font-medium focus:outline-none focus:border-kiki-yellow"
                  />
                  <button
                    type="submit"
                    className="btn-bouncy px-4 py-2.5 rounded-2xl bg-kiki-yellow text-slate-900 font-heading font-bold text-xs shadow-md whitespace-nowrap"
                  >
                    Subscribe
                  </button>
                </div>
                <span className="text-[11px] text-slate-500 block">We respect your inbox and never share data.</span>
              </form>
            )}
          </div>

        </div>

        {/* Bottom Credits */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500 font-semibold gap-4">
          <p>© {new Date().getFullYear()} kikiandkids.com. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#safety" className="hover:text-slate-300 transition-colors">Child Safety Statement</a>
            <span>•</span>
            <a href="#curriculum" className="hover:text-slate-300 transition-colors">Standards Mapping</a>
          </div>
        </div>

      </div>
    </footer>
  );
}
